// extracted by mini-css-extract-plugin
module.exports = {"form":"ReferralSystemForm_form__QCD0e","field":"ReferralSystemForm_field__2igjF","input":"ReferralSystemForm_input__2auhR","submitButton":"ReferralSystemForm_submitButton__1rZbk"};